export default "__VITE_ASSET__C$EQo82d__"